export default "__VITE_ASSET__2nLEog_s__"